<div>

  <div class="row">

    @if (state === 0) {
      <workflow-create-article-search (offerEmitter)="showWorkflow($event)" (nextEmitter)="next($event)">
      </workflow-create-article-search>
    }

    @if (state === 0 && !error && !!offerData) {
      <create-task [data]="offerData" class="col-md-5">
      </create-task>
    }

    @if (error && state === 0) {
      <div class="col-md-5">
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <h3>Angebot hat schon einen Auftrag!</h3>
      </div>
    }

  </div>

  <!-- ="$ctrl.finish(typ, customer, contact)"-->
  @if (state === 1) {
    <workflow-create-customer [data]="customerData" (finishEmitter)="finish($event)">
    </workflow-create-customer>
  }

</div>
